import classes from '../ComponentOverflow.module.scss'
import type { ReactNode } from 'react'

interface Props {
  placeholderHeader?: ReactNode
  children: ReactNode[]
  gap: number
}

const OverflowTooltip = ({
  placeholderHeader,
  children,
  gap
}: Props) =>
  <div className={classes.OverflowTooltips}>
    {
      placeholderHeader && placeholderHeader
    }
    <div
      className={classes.ChildrenList}
      style={{ gap: `${gap}px` }}
    >
      {
        children
      }
    </div>
  </div>

export default OverflowTooltip
